import { http } from '@/lib/http';
import type { FindAllResponse } from '@/types/api/find-all-response';
import type { Couple } from 'generated/prisma/browser';
import {
  renderCoupleList,
  renderFicha,
  type PrintCouple,
  type PrintEvent,
} from './sheets';

type Open = (title: string, html: string) => void;

const firstName = (name?: string) => (name ?? '').split(' ')[0];

/** Ficha em branco (ou preenchida, quando há casal) do encontro. */
export function printFicha(open: Open, event?: PrintEvent, couple?: PrintCouple) {
  const title = couple
    ? `Ficha de inscrição — ${firstName(couple.husbandName)} e ${couple.wifeName ?? ''}`
    : event
      ? `Ficha de inscrição — ${event.description}`
      : 'Ficha de inscrição';
  open(title, renderFicha(event, couple));
}

/** Casais ativos do encontro, ordenados pelo nome do esposo. */
export async function printCoupleList(open: Open, event: PrintEvent & { id: string }) {
  const { data } = await http.get<FindAllResponse<Couple>>('couples', {
    params: {
      eventId: event.id,
      isActive: true,
      perPage: 1000,
      orderBy: 'husbandName',
      order: 'asc',
    },
  });

  const couples = [...data.data].sort((a, b) =>
    a.husbandName.localeCompare(b.husbandName, 'pt-BR'),
  );
  open(`Lista de casais — ${event.description}`, renderCoupleList(event, couples));
}
